import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  assistants: [],
  currentAssistant: null,
  isLoading: false,
  error: null,
};

const AssistantsSlice = createSlice({
  name: "assistants",
  initialState,
  reducers: {
    setAssistants: (state, action) => {
      state.assistants = action.payload;
    },
    setCurrentAssistant: (state, action) => {
      state.currentAssistant = action.payload;
    },
    addAssistant: (state, action) => {
      state.assistants.push(action.payload);
    },
    updateAssistant: (state, action) => {
      const index = state.assistants.findIndex(
        (assistant) => assistant.id === action.payload.id
      );
      if (index !== -1) {
        state.assistants[index] = action.payload;
      }
    },
    deleteAssistant: (state, action) => {
      state.assistants = state.assistants.filter(
        (assistant) => assistant.id !== action.payload
      );
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearCurrentAssistant: (state) => {
      state.currentAssistant = null;
    },
  },
});

export const {
  setAssistants,
  setCurrentAssistant,
  addAssistant,
  updateAssistant,
  deleteAssistant,
  setLoading,
  setError,
  clearCurrentAssistant,
} = AssistantsSlice.actions;

export default AssistantsSlice.reducer;
